
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../lib/redux/hook";
import { colors } from "../../ui/colors";
import { EmailIcon } from "../../ui/icons/emailIcon";
import { BillowButton } from "../../ui/molecules/billowButton";
import { InputComponent } from "../../ui/molecules/input/index";
import { ModalComponent } from "../../ui/organisms/modal/index";
import { createCustomer, editCustomer, resetCustomerCreateRequest, setCreateCustomerEmail, setCreateCustomerMarkupRate, setCreateCustomerMinQuota, setCreateCustomerName, setCreateCustomerNamespacek8s, setCreateCustomerSurname, setCreateCustomerVat, setCustomerId, setEditCustomerMarkupRate, setEditCustomerMinQuota, setEditCustomerName, setEditCustomerSurname, setOpenNewCustomerModal } from "./slice";

export function NewCustomerModal() {
    const customerState = useAppSelector(state => state.customer)
    const dispatch = useAppDispatch()
    const [moreNamespaces, setMoreNamespaces] = useState<string[]>([''])

    useEffect(() => {
        if (customerState.customerId.trim()) {
            const customer = customerState.findAllCustomersResponse?.customers.find(item => item.id.toString() === customerState.customerId)
            dispatch(setEditCustomerName(customer?.name))
            dispatch(setEditCustomerSurname(customer?.surname))
            dispatch(setEditCustomerMarkupRate(customer?.markup_rate))
            dispatch(setEditCustomerMinQuota(customer?.min_quota))
            dispatch(setCreateCustomerNamespacek8s(customer?.namespace_k8s))
            dispatch(setCreateCustomerEmail(customer?.email))
            dispatch(setCreateCustomerVat(customer?.vat))
        }
    }, [customerState.customerId])

    useEffect(() => {
        if (customerState.openNewCustomerModal) {
            dispatch(resetCustomerCreateRequest())
        }
    }, [customerState.openNewCustomerModal])

    return (
        <ModalComponent
            width="medium"
            open={customerState.openNewCustomerModal || customerState.customerId.trim().length > 0}
            handleClose={() => {
                dispatch(setOpenNewCustomerModal(false));
            }}
        >
            <div
                style={{
                    padding: '20px',
                    backgroundColor: colors.white,
                    boxShadow: '0px 12px 24px 0px rgba(22, 42, 100, 0.12)',
                    borderRadius: '12px',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '20px',
                    width: '100%'
                }}
            >
                <div className="flex items-center justify-between">
                    <span className="text-heading-xs font-semibold text-neutral-600">{customerState.customerId.trim() ? 'Modifica cliente' : 'Aggiungi cliente'}</span>
                </div>
                <div className="flex flex-col items-start" style={{ gap: '16px', width: '100%' }}>
                    <div className=" flex flex-row gap-4">
                        <InputComponent
                            label="Nome"
                            type={"text"}
                            value={customerState.customerId.trim() ? customerState.editCustomerRequest.name : customerState.createCustomerRequest.name}
                            placeholder={"Nome"}
                            onChangeText={(value) =>
                                customerState.customerId.trim() ?
                                    dispatch(setEditCustomerName(value)) :
                                    dispatch(setCreateCustomerName(value))}
                            required
                        />
                        <InputComponent
                            label="Cognome"
                            type={"text"}
                            value={customerState.customerId.trim() ? customerState.editCustomerRequest.surname : customerState.createCustomerRequest.surname}
                            placeholder={"Cognome"}
                            onChangeText={(value) => customerState.customerId.trim() ?
                                dispatch(setEditCustomerSurname(value)) :
                                dispatch(setCreateCustomerSurname(value))}
                            required
                        />
                    </div>
                    <InputComponent
                        label="Email"
                        type={"text"}
                        placeholder="Email"
                        disabled={customerState.customerId.trim().length > 0}
                        startIcon={<EmailIcon size={"20"} color={colors.neutral[400]} />}
                        value={customerState.createCustomerRequest.email}
                        onChangeText={(value) => dispatch(setCreateCustomerEmail(value.toLowerCase()))}
                        required
                    />
                    {moreNamespaces.map((item, index) =>
                        <div className='flex flex-col gap-1 w-full'>
                            <InputComponent
                                label={index === 0 ? "Namespace k8s" : undefined}
                                type={"text"}
                                placeholder="Namespace k8s"
                                value={item}
                                onChangeText={(value) => {
                                    setMoreNamespaces(prev => {
                                        const updated = [...prev];
                                        updated[index] = value;
                                        return updated;
                                    });
                                }}
                                required={index === 0}
                            />
                            {index === moreNamespaces.length - 1 && <span onClick={() => setMoreNamespaces((prev) => [...prev, ''])} className=" text-[#6237fb] text-text-sm hover:opacity-80 cursor-pointer">+ Aggiungi Namespace</span>}
                        </div>
                    )}
                    <InputComponent
                        label="Tasso di maggiorazione"
                        type={"text"}
                        placeholder="Tasso di maggiorazione"
                        startIcon={<div className=" text-neutral-400 text-text-sm">%</div>}
                        value={customerState.customerId.trim() ? customerState.editCustomerRequest.markup_rate : customerState.createCustomerRequest.markup_rate}
                        onChangeText={(value) => {
                            customerState.customerId.trim() ?
                                dispatch(setEditCustomerMarkupRate(Number(value))) :
                                dispatch(setCreateCustomerMarkupRate(Number(value)))

                        }}
                        required
                    />
                    <InputComponent
                        label="Quota minima (prezzo i.e.)"
                        type={"text"}
                        placeholder="Quota minima"
                        value={customerState.customerId.trim() ? customerState.editCustomerRequest.min_quota : customerState.createCustomerRequest.min_quota}
                        onChangeText={(value) => {
                            customerState.customerId.trim() ?
                                dispatch(setEditCustomerMinQuota(Number(value))) :
                                dispatch(setCreateCustomerMinQuota(Number(value)))

                        }}
                        required
                    />
                </div>
                <div className={"flex gap-3 items-center w-full justify-center"}>
                    <BillowButton
                        label={"Annulla"}
                        onClick={() => {
                            setMoreNamespaces([''])
                            dispatch(setOpenNewCustomerModal(false))
                            dispatch(setCustomerId(''))
                            dispatch(resetCustomerCreateRequest())
                        }}
                        variant={"outline"}
                        iconPosition="off"
                        fullWidth
                    />
                    <BillowButton
                        label={customerState.customerId.trim() ? "Modifica" : "Aggiungi"}
                        onClick={() => {
                            if (!customerState.customerId.trim())
                                dispatch(createCustomer({ ...customerState.createCustomerRequest, namespace_k8s: moreNamespaces.filter(elem => elem.trim()) }))
                            else
                                dispatch(editCustomer({
                                    id: customerState.customerId,
                                    request: customerState.editCustomerRequest
                                }))
                            setMoreNamespaces([''])
                            dispatch(setCustomerId(''))
                            dispatch(setOpenNewCustomerModal(false))
                        }}
                        variant={"solid"}
                        iconPosition="off"
                        fullWidth
                        disabled={
                            (!customerState.customerId.trim() && (customerState.createCustomerRequest.name === "" ||
                                customerState.createCustomerRequest.surname === "" ||
                                customerState.createCustomerRequest.email === "" ||
                                (!moreNamespaces[0].trim()) ||
                                !/^[A-z0-9\.\+_-]+@[A-z0-9\._-]+\.[A-z]{2,6}$/.test(customerState.createCustomerRequest.email)))
                        }
                    />
                </div>
            </div>
        </ModalComponent >
    )
}